import React, { useContext } from "react";
import {UsuarioContext} from './personaContext';


const ProtectedRoute = ({ allowedRoles, children }) => {
      const persona = useContext(UsuarioContext);
      if (!persona?.persona?.rol) {
              return null;
      }
    
    if (!persona || allowedRoles && !allowedRoles.includes(persona.persona.rol.toLowerCase())) {
        return null;
    }

    return <>{children}</>;
};

export default ProtectedRoute;